import React, { Component } from 'react';

class TableHeader extends Component {
    raiseSort = (path) => {

        let sort_column = this.props.sortColumn;

        const sortColumn = {...sort_column};

        if(sortColumn.path === path)
        {
            sortColumn.order = (sortColumn.order ==="asc" ? "desc" : "asc");
        }
        else
        {
            sortColumn.path = path;
            sortColumn.order = "asc";
        }

        this.props.onSort(sortColumn);
    };

    renderSortIcon = (column) => {
        const {sortColumn} = this.props;
        if(column.path !== sortColumn.path) return null;
        if(sortColumn.order === "asc") return <i className="glyphicon glyphicon-sort-by-attributes pull-right"></i>;
        return <i className="glyphicon glyphicon-sort-by-attributes-alt pull-right"></i>;
    };


    render() {

        return (
            <thead>
            <tr>
                {this.props.columns.map((column, index) => (
                    <th className="clickable" key={index} onClick={() => this.raiseSort(column.path)}>
                        {column.label}
                        {this.renderSortIcon(column)}
                    </th>

                ))
                }
            </tr>
            </thead>
        );
    }
}

export default TableHeader
